import type { FaireProductEntity } from "../../entity_types/product";

export const p_rb9gr667zc: FaireProductEntity = {
  token: "p_rb9gr667zc",
  type: "product",
  name: "The Natural First Aid Handbook",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl:
    "https://cdn.faire.com/fastly/aede1e9c15bda67b235be931755335f5a8b95e83e0dc822df1aebd2c039a2d32.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.39,
  description:
    "This A-to-Z guide to the most common emergency situations, ailments, and injuries focuses on how to use household, herbal, and homeopathic remedies safely and effectively in combination with basic emergency-response procedures and protocols.\nCayenne pepper can stop bleeding. Garlic helps alleviate a toothache. Honey soothes a burn. When an emergency situation arises, simple home remedies can play a vital role in easing symptoms and providing immediate help. Become an effective first responder with a combination of best first-aid practices, herbs, and standard homeopathic applications. This quick-reference handbook spells out hundreds of life-saving techniques, commonsense tips, and time-tested herbal remedies that everyone should know. From how to perform basic CPR and the Heimlich Maneuver to the best immediate response to natural disasters, you’ll find the most practical, effective actions to take to ensure survival.",
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:43.540Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
